module.exports = __webpack_public_path__ + "media/VID-20221028-WA0000.fd94d1a2.mp4";